import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class GetPspList<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(
      apiService,
      adapter,
      `${environment.userApiUrl}/tenant-configs/patient-support-programs`,
    );
  }
}
